import { FC } from 'react';
import { UserRole } from '../../../services/models.types';
import WorkboardModelsTable from '../WorkboardModelsTable/WorkboardModelsTable';

const WorkboardPastModels: FC = () => (
  <WorkboardModelsTable 
    currentUserRole={UserRole.REVIEWER}
    filterType="past"
  />
);

export default WorkboardPastModels;
